import { LoadableAfterPaint } from '@confluence/loadable';

export type {
	EndOfPageRecommendationQuery as EndOfPageRecommendationData,
	EndOfPageRecommendationQueryVariables,
} from './__types__/EndOfPageRecommendationQuery';

export const EndOfPageRecAdminConfig = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndOfPageRecAdminConfig" */ './EndOfPageRecAdminConfig'
			)
		).EndOfPageRecAdminConfig,
});

export { EndOfPageHideConfirmModal } from './EndOfPageHideConfirmModal';
export { EndOfPageRecHideStatusMutation } from './EndOfPageRecHideStatusMutation.graphql';
export { EndOfPageRecommendationQuery } from './EndOfPageRecommendationQuery.graphql';
export { transformEndOfPageRecContent } from './transformers';
